import { inject } from '@angular/core'
import { CanActivateFn } from '@angular/router'
import { AuthDomain } from '../../shared/domain/auth.domain'
import { filter, Observable, switchMap, tap } from 'rxjs'

export function authGuard(): CanActivateFn {
  return (state): Observable<boolean> => {
    const authDomain: AuthDomain = inject(AuthDomain)

    return authDomain.isDoneLoading$.pipe(
      filter((isDone) => isDone),
      switchMap(() => authDomain.isAuthenticated$),
      tap((isAuthenticated) => isAuthenticated || authDomain.login(state.url))
    )
  }
}
